import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { createTeamDocument, getGameByCode, checkTeamExists } from '../firebase/db';
import { Container, Heading, Description, StartButton, ButtonWrapper, Input, Dropdown, BackgroundWrapper } from '../styles/HomePage.styles';
import eduventraLogoNoText from '../data/eduventra_logo_notext-removebg.png';
import { useToast } from './Toast';

const HomePage = () => {
    const [teamName, setTeamName] = useState('');
    const [teamType, setTeamType] = useState('');
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const gameCode = searchParams.get('game');
    const [gameId, setGameId] = useState(null);
    const [gameError, setGameError] = useState('');
    const { showToast, ToastContainer } = useToast();

    useEffect(() => {
        const resolveGame = async () => {
            if (gameCode) {
                const game = await getGameByCode(gameCode);
                if (game) {
                    setGameId(game.gameId);
                } else {
                    setGameError('Invalid game code. Please check the link from your instructor.');
                }
            }
        };
        resolveGame();
    }, [gameCode]);

    const handleStart = async () => {
        if (gameError) {
            showToast(gameError, 'error');
            return;
        }
        if (gameCode && !gameId) {
            showToast("Loading game info, please wait a moment and try again.", 'info');
            return;
        }
        if (!teamName.trim()) {
            showToast("Please enter a team name.", 'error');
        } else if (teamName.includes(" ")) {
            showToast("Please select a team name without a space.", 'error');
        } else if (!teamType) {
            showToast("Please select a submission type.", 'error');
        } else {
            try {
                const exists = await checkTeamExists(teamName, teamType);
                if (exists) {
                    const resume = window.confirm(
                        `A team named "${teamName}" already exists. Click OK to continue with that team, or Cancel to choose a different name.`
                    );
                    if (!resume) return;
                }
                await createTeamDocument(teamName, teamType, gameId);
                // Save to localStorage for student dashboard
                const existingTeams = JSON.parse(localStorage.getItem('studentTeams') || '[]');
                const entry = {
                    teamName,
                    teamType,
                    gameId: gameId || null,
                    gameCode: gameCode || null,
                    joinedAt: new Date().toISOString(),
                };
                const existingIndex = existingTeams.findIndex(
                    t => t.teamName === teamName && t.teamType === teamType
                );
                if (existingIndex >= 0) {
                    existingTeams[existingIndex] = entry;
                } else {
                    existingTeams.push(entry);
                }
                localStorage.setItem('studentTeams', JSON.stringify(existingTeams));
                navigate(`/${teamName}_${teamType}/home`);
            } catch (error) {
                showToast("Error creating team. Please try again.", 'error');
                console.error('Error creating team document:', error);
            }
        }
    };

    return (
        <div>
            {ToastContainer}
            <BackgroundWrapper>
                <img src={eduventraLogoNoText} alt="Eduventra Logo" style={{ width: '10vw', marginBottom: '3vw' }} />
                <Container>
                    <Heading>Welcome to the Cuban Bike Case Study</Heading>
                    <Description>
                        Ready to pedal innovation into the Cuban market and redefine the biking experience?
                    </Description>
                    {gameCode && !gameError && (
                        <p style={{ color: '#007bff', fontSize: '14px', marginBottom: '10px' }}>
                            Joining game: <strong>{gameCode.toUpperCase()}</strong>
                        </p>
                    )}
                    {gameError && (
                        <p style={{ color: '#e15759', fontSize: '14px', marginBottom: '10px' }}>
                            {gameError}
                        </p>
                    )}
                    <Input
                        type="text"
                        placeholder="Enter your team name"
                        value={teamName}
                        onChange={(e) => setTeamName(e.target.value)}
                    />
                    <Dropdown
                        value={teamType}
                        onChange={(e) => setTeamType(e.target.value)}
                    >
                        <option value="" disabled={true}>Select submission type...</option>
                        <option value="Master">Master</option>
                        <option value="Test">Test</option>
                    </Dropdown>
                    {teamType === 'Test' && (
                        <p style={{ color: '#2c2e2d', fontSize: '16px', marginTop: '8px' }}>
                            <strong>Note:</strong> Use a <b>unique name</b> for <em>each</em> test submission on your team.
                        </p>
                    )}
                    <ButtonWrapper>
                        <StartButton onClick={handleStart}>Start the Case Study</StartButton>
                    </ButtonWrapper>
                    <button
                        onClick={() => navigate('/professor-login')}
                        style={{
                            background: 'none', border: 'none', color: '#555',
                            cursor: 'pointer', fontSize: '13px', marginTop: '20px',
                            textDecoration: 'underline', opacity: 0.7,
                        }}
                    >
                        Instructor Login
                    </button>
                </Container>
            </BackgroundWrapper>
        </div>
    );
};

export default HomePage;

// --- AUTH-BASED VERSION (commented out, switch back when ready) ---
// import React from 'react';
// import { Container, Heading, Description, BackgroundWrapper } from '../styles/HomePage.styles';
// import eduventraLogoNoText from '../data/eduventra_logo_notext-removebg.png';
// import Auth from '../components/Auth';
//
// const HomePage = () => {
//   return (
//     <div>
//       <BackgroundWrapper>
//         <img src={eduventraLogoNoText} alt="Eduventra Logo" style={{ width: '10vw', marginBottom: '3vw' }} />
//         <Container>
//           <Heading>Welcome to the Cuban Bike Case Study</Heading>
//           <Description>
//             Sign up or sign in to start your journey in redefining the biking experience in the Cuban market.
//           </Description>
//           <Auth />
//         </Container>
//       </BackgroundWrapper>
//     </div>
//   );
// };
//
// export default HomePage;
